/**
 * Author: Umayr Shahid <umayrr@hotmail.com>,
 * Created: 17:05, 17/08/15.
 */

'use strict';

import Cressida from './classes/cressida';
export default Cressida;
